import { PROJECT_UNITS_PER_METRE } from './projectMetrics';

// A confirmed reference belongs to one immutable customer model. Never apply it to
// catalog houses or trackers, nor overwrite an existing calibration automatically.
export function applyProjectBuildingReference(controls: any, reference: any, modelId: string | null, onlyUncalibrated = false): number {
  const metres = reference?.reference?.metres;
  if (!modelId || !reference?.confirmed_at || reference.model_id !== modelId || !Number.isFinite(metres) || metres <= 0) {
    throw new Error('Keine passende bestätigte Gebäudehöhe für das geladene Kundenmodell.');
  }
  const snapshot = controls?.getBuilderSnapshot?.() || [];
  const houses = (controls?.getProjectObjectDimensions?.() || []).filter((d: any) =>
    d.kind === 'house' && snapshot[d.index]?.cfg?.source === 'site-model' && (!onlyUncalibrated || !d.reference));
  for (const house of houses) {
    controls.selectBuilderObject(house.id);
    const result=reference.reference.footprint
      ? controls.fitSelectedBuilding(reference.reference)
      : controls.calibrateSelectedBuilder('y', metres * PROJECT_UNITS_PER_METRE, reference.reference);
    if (!result) {
      throw new Error('Kundenhaus konnte nicht skaliert werden.');
    }
  }
  return houses.length;
}
